module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon33.77e709bc.png";